import { BaseError } from "./BaseError";

export class NotFoundError extends BaseError {
  readonly status = 404;
}
